/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const CORPORATION_TYPE = {
    SCHOOL:           'SCHOOL',
    SCHOOL_AUTHORITY: 'SCHOOL_AUTHORITY'
}
export default CORPORATION_TYPE